<template>
  <div :class="optionClasses" @click="optionClicked" :data-cy="`item-modal-option-${option.id}`">
    <input 
      :type="optionType" 
      :id="optionId" 
      :name="`option_${metaIndex}`" 
      class="custom-control-input"
      @change="optionChanged($event)" 
      :value="option.price" 
      :checked="checked"
      :disabled="disabled">
    <label class="custom-control-label" :for="optionId">{{optionText}}</label>
  </div>
</template>

<script>
export default {
  name: "ItemOption",
  props: {
    option: Object,
    metaIndex: Number,
    meta: Object,
    item: Object
  },
  created: function() {
    this.random = Math.floor(Math.random() * 9999);
  },
  methods: {
    optionClicked() {
      if (this.optionType == "radio" && this.checked && !this.meta.required) {
        this.$emit("change", {
          meta: this.meta, 
          option: this.option, 
          checked: false
        })
      }
    },
    optionChanged($event) {
      this.$emit("change", {
        meta: this.meta, 
        option: this.option, 
        checked: $event.target.checked
      })
    }
  },
  computed: {
    optionId() {
      return `${this.random}_${this.option.name.split(' ').join('_')}`;
    },
    optionText() {
      if (this.option.price > 0)
        return this.option.name + ' (+ $' + this.option.price + ')'
      else
        return this.option.name 
    },
    optionType() {
      return this.meta.max_allowed_values == 1 ? "radio" : "checkbox"
    },
    optionClasses() {
      return this.meta.max_allowed_values == 1 ? "custom-control custom-radio" : "custom-control custom-checkbox"
    },
    itemOptions() {
      return this.item.options && this.item.options[this.meta.key] ? this.item.options[this.meta.key] : null
    },
    disabled() {
      if (this.itemOptions && this.meta.max_allowed_values > 1) {
        return this.itemOptions.length >= this.meta.max_allowed_values && !this.checked
      }
      return false
    },
    checked() {
      if (this.itemOptions) {
        const option = this.itemOptions.find(option => this.option.id == option.id)
        return option ? option.checked : false
      }
      return false
    }
  }
};
</script>